export class CampaignDetail {
    public Email: string = "";
    public Name: string = "";
    public Reference: string = "";
    public GUID: string = "";
    public FailedCheck: boolean = false;
    public DetailID: number = -1;
    public Sent: boolean = false;
    public Accessed: boolean = false;
    public Completed:boolean = false;
    public FailedDelivery: boolean = false;
    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}